// extracted by mini-css-extract-plugin
export default {"description":"style_description__uqFKm","fade-in":"style_fade-in__yuJul","top":"style_top__LRBn5","image":"style_image__MLYnN"};